export default {
  namespaced: true,
  facility_category: {
    title: "Categoría de Instalación | Categorías de Instalaciones",
    name: "Nombre",
    description: "Descripción",
  },
};
